<script setup lang="ts">
import { computed } from 'vue'
import { BasicButton } from 'wepin-vue-component'
import { useI18nTypes } from '@/composables'
const { t } = useI18nTypes()
const props = withDefaults(
  defineProps<{
    disabled?: boolean
    confirmText?: string
    cancelText?: string
  }>(),
  {
    disabled: false,
    confirmText: '',
    cancelText: '',
  },
)
const computedConfirmText = computed(() => {
  if (props.confirmText === '') return t('global.confirm')
  return props.confirmText
})

const computedCancelText = computed(() => {
  if (props.cancelText === '') return t('global.cancel')
  return props.cancelText
})
defineEmits(['cancel', 'confirm'])
</script>
<template>
  <div class="buttons">
    <BasicButton type="outlined" width="100%" @click="$emit('cancel')">
      {{ computedCancelText }}
    </BasicButton>
    <BasicButton
      type="primary"
      :disabled="disabled"
      width="100%"
      @click="disabled ? undefined : $emit('confirm')"
    >
      {{ computedConfirmText }}
    </BasicButton>
  </div>
</template>
<style scoped lang="scss">
.buttons {
  display: flex;
  gap: 10px;
}
</style>
